import React, { useEffect, useState, useRef } from 'react';
import { Button, Form, Input, ConfigProvider, Modal, Table, message, Select, Tag, Space, Typography } from 'antd';
import { SearchOutlined, SettingOutlined, SyncOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { hnrequest } from '@/utils'
import zhCN from 'antd/locale/zh_CN';
const { Paragraph, Text } = Typography;
const Usa = () => {
    const [messageApi, contextHolder] = message.useMessage();
    const [open, setOpen] = useState(false);
    // const [openset, setOpenset] = useState(false);
    const [opensetp, setOpensetp] = useState(false);
    const [tabm, settabm] = useState([]);
    const [ccpxx, setccpxx] = useState([]);// 选择的产品信息
    const [ztv, setZtv] = useState(0);


    const [setpsw] = Form.useForm();
    const [uadd] = Form.useForm();

    useEffect(() => {
        async function getau() {
            const res2 = await hnrequest.post('/p_uzlist')
            settabm(res2.rescode)
        }

        getau()

    }, [ztv])

    const onFinish = async (value) => {
        setOpen(false)
        const rzs = await hnrequest.post('/p_uzadd', value)
        messageApi.open({
            type: rzs.return_code,
            content: rzs.return_msg,
        })
        setZtv(rzs.ticks)

    };


    const onFinishsetp = async (value) => {
        setOpensetp(false)
        const rzs = await hnrequest.post('/p_uzsetp', value)
        messageApi.open({
            type: rzs.return_code,
            content: rzs.return_msg,
        })
        setZtv(rzs.ticks)
    };

    const gohf = (v, b) => {
        setccpxx(v)
        b === "setpsw" && setOpensetp(true)
        b === "setpsw" && setpsw.setFieldsValue({ dbno: v.key, });
    }








    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`检索内容`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        检索
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        重置
                    </Button>

                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        关闭
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        filterDropdownProps: {
            onOpenChange(open) {
                if (open) {
                    setTimeout(() => searchInput.current?.select(), 100);
                }
            },
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });


    const columns = [
        {
            title: <Button type="primary" onClick={() => { setOpen(true) }}>添加</Button>,
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Tag color="green" onClick={() => gohf(record, 'setqx')}><SettingOutlined /> 权限设置</Tag>
                    {true && <Tag color="cyan" onClick={() => gohf(record, 'setpsw')}><SyncOutlined />密码重置</Tag>}

                </Space>
            ),
        },
        {
            title: '登录账号',
            dataIndex: 'uzname',
            key: 'uzname',
            ...getColumnSearchProps('uzname'),
        },
        {
            title: '使用者名称',
            dataIndex: 'uzmc',
            key: 'uzmc',
            ...getColumnSearchProps('uzmc'),        
        },
      

    ];




    return <ConfigProvider locale={zhCN}>
        <>{contextHolder}


            <Table columns={columns} dataSource={tabm} key='qyrztab' />

            <Modal
                title="添加内部账号"
                centered
                open={open}
                footer={null}

                onCancel={() => setOpen(false)}
                width={800}
            >
                <Form
                    name="uadd"
                    labelCol={{
                        flex: '110px',
                    }}
                    labelAlign="left"
                    labelWrap
                    wrapperCol={{
                        flex: 1,
                    }}
                    colon={false}
                    style={{
                        maxWidth: 600,
                    }}
                    form={uadd}
                    onFinish={onFinish}
                >
                    <Form.Item
                        label="登录账号"
                        name="uzname" key="uzname"
                        rules={[
                            { required: true, message: '请填写员工账号！' },
                            { pattern: /^[A-Za-z0-9]+$/, message: '请以字母或者数字作为员工账号!' }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="登录密码"
                        name="uzpsw" key="uzpsw"
                        rules={[
                            {
                                required: true, message: '请填写登录密码！'
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="用者名称"
                        name="uzmc" key="uzmc"
                        rules={[
                            {
                                required: true, message: '请填写使用者名称！'
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="备注标签"
                        name="uznote" key="uznote"
                        rules={[
                            {
                                required: true, message: '请填写正确的公司账户！'
                            },
                        ]}
                    >
                        <Select
                            mode="tags"
                            style={{
                                width: '100%',
                            }}
                            tokenSeparators={[',']}
                            placeholder='产品标签，方便查询，不对外展示'
                        />
                    </Form.Item>
                    <Form.Item label=" " key='tsubbutton'>
                        <Button type="primary" block={true} htmlType="submit">
                            提交
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>




            <Modal
                title="重置密码"
                centered
                open={opensetp}
                footer={null}
                onCancel={() => setOpensetp(false)}
                width={800}
            >
                <Paragraph> 登录账号：{ccpxx.uzname} <Text>使用者名称：{ccpxx.uzmc}</Text> </Paragraph>
                <Form
                    name="setpsw"
                    labelCol={{
                        flex: '110px',
                    }}
                    labelAlign="left"
                    labelWrap
                    wrapperCol={{
                        flex: 1,
                    }}
                    colon={false}
                    style={{
                        maxWidth: 600,
                    }}
                    form={setpsw}
                    onFinish={onFinishsetp}
                >
                    <Form.Item name="dbno" key="dbno" hidden="true">
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="登录密码"
                        name="uzpsw" key="uzpsw"
                        rules={[
                            {
                                required: true, message: '请填写登录密码！'
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item label=" " key='tsubbutton'>
                        <Button type="primary" block={true} htmlType="submit">
                            提交
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>

























        </>

    </ConfigProvider>


}

export default Usa